import {
  extractNoteText,
  extractReasonCoding,
  isProcedureServiceRequest,
} from "./editHydrationHelpers";

/**
 * Converte ServiceRequest FHIR → intervenção type "service" | "procedure".
 * Espelha SelectProtocolDialog.generateService / ExamsFields / ProcedureAndCertificate.
 */
export function mapServiceRequestToIntervention(serviceRequest: any) {
  const coding = serviceRequest?.code?.concept?.coding?.[0];
  const serviceName = coding?.display || coding?.code || "Exame/Procedimento";
  const reasonCoding = extractReasonCoding(serviceRequest?.reason);
  const categoryCoding = serviceRequest?.category?.find(
    (c: any) => c?.coding?.[0]
  )?.coding?.[0];
  const procedure = isProcedureServiceRequest(serviceRequest);
  const noteText = extractNoteText(serviceRequest?.note);

  if (procedure) {
    return {
      name: serviceName,
      tag: "PROC",
      inputValue: {
        name: serviceName,
        label: serviceName,
        value: serviceName,
        ...(coding?.code && { code: coding.code }),
      },
      note: noteText,
      form: "",
      type: "procedure",
      tabValue: "1",
      fromEditHydration: true,
      serviceRequestId: serviceRequest?.id,
      // Preserva agrupamento do lote para PUT (não regenerar requisition)
      ...(serviceRequest?.requisition && {
        requisition: serviceRequest.requisition,
      }),
      ...(serviceRequest?.identifier && {
        identifier: serviceRequest.identifier,
      }),
    };
  }

  return {
    type: "service",
    tabValue: "2",
    inputValue: {
      ...(coding?.code && {
        code: coding.code,
        system:
          coding?.system ||
          "https://fluxmed.com.br/fhir/r5/CodeSystem/TUSSProcedimentosEventos",
      }),
      display: serviceName,
      name: serviceName,
      value: serviceName,
      label: serviceName,
    },
    name: serviceName,
    tag: "EX",
    form: "",
    note: noteText,
    ...(reasonCoding && {
      condition: {
        code: reasonCoding?.code,
        display: reasonCoding?.display,
        label: reasonCoding?.display
          ? `${reasonCoding?.code ? `${reasonCoding.code} - ` : ""}${reasonCoding.display}`
          : reasonCoding?.code,
        system:
          reasonCoding?.system ||
          "https://fluxmed.com.br/fhir/r4/CodeSystem/CID10",
        value: reasonCoding?.code,
      },
    }),
    // Sempre define category (objeto) para TabsAssinatura.translateExams / Footer
    // não quebrarem quando o ServiceRequest não trouxe coding de categoria.
    category: categoryCoding
      ? {
          code: categoryCoding?.code,
          display: categoryCoding?.display,
          label: categoryCoding?.display || categoryCoding?.code,
          value: categoryCoding?.code,
        }
      : { code: undefined, display: undefined, label: "Geral" },
    fromEditHydration: true,
    serviceRequestId: serviceRequest?.id,
    // Preserva agrupamento do lote para PUT (não regenerar requisition)
    ...(serviceRequest?.requisition && {
      requisition: serviceRequest.requisition,
    }),
    ...(serviceRequest?.identifier && {
      identifier: serviceRequest.identifier,
    }),
  };
}
